export const getExerciseInfo = (t) => ({
  emotion_register: {
    title: t("exerciseData.emotion_register.title"),
    objectives: [
      t("exerciseData.emotion_register.obj1"),
      t("exerciseData.emotion_register.obj2"),
      t("exerciseData.emotion_register.obj3"),
      t("exerciseData.emotion_register.obj4"),
    ],
    explanation: t("exerciseData.emotion_register.explanation"),
    foundation: t("exerciseData.emotion_register.foundation"),
  },
  behavioral_activation: {
    title: t("exerciseData.behavioral_activation.title"),
    objectives: [
      t("exerciseData.behavioral_activation.obj1"),
      t("exerciseData.behavioral_activation.obj2"),
      t("exerciseData.behavioral_activation.obj3"),
      t("exerciseData.behavioral_activation.obj4"),
    ],
    explanation: t("exerciseData.behavioral_activation.explanation"),
    foundation: t("exerciseData.behavioral_activation.foundation"),
  },
  mood_tracking: {
    title: t("exerciseData.mood_tracking.title"),
    objectives: [
      t("exerciseData.mood_tracking.obj1"),
      t("exerciseData.mood_tracking.obj2"),
      t("exerciseData.mood_tracking.obj3"),
      t("exerciseData.mood_tracking.obj4"),
    ],
    explanation: t("exerciseData.mood_tracking.explanation"),
    foundation: t("exerciseData.mood_tracking.foundation"),
  },
  pomodoro: {
    title: t("exerciseData.pomodoro.title"),
    objectives: [
      t("exerciseData.pomodoro.obj1"),
      t("exerciseData.pomodoro.obj2"),
      t("exerciseData.pomodoro.obj3"),
      t("exerciseData.pomodoro.obj4"),
    ],
    explanation: t("exerciseData.pomodoro.explanation"),
    foundation: t("exerciseData.pomodoro.foundation"),
  },
  cognitive_defusion: {
    title: t("exerciseData.cognitive_defusion.title"),
    objectives: [
      t("exerciseData.cognitive_defusion.obj1"),
      t("exerciseData.cognitive_defusion.obj2"),
      t("exerciseData.cognitive_defusion.obj3"),
      t("exerciseData.cognitive_defusion.obj4"),
    ],
    explanation: t("exerciseData.cognitive_defusion.explanation"),
    foundation: t("exerciseData.cognitive_defusion.foundation"),
  },
  meditation: {
    title: t("exerciseData.meditation.title"),
    objectives: [
      t("exerciseData.meditation.obj1"),
      t("exerciseData.meditation.obj2"),
      t("exerciseData.meditation.obj3"),
      t("exerciseData.meditation.obj4"),
    ],
    explanation: t("exerciseData.meditation.explanation"),
    foundation: t("exerciseData.meditation.foundation"),
  },
  gratitude: {
    title: t("exerciseData.gratitude.title"),
    objectives: [
      t("exerciseData.gratitude.obj1"),
      t("exerciseData.gratitude.obj2"),
      t("exerciseData.gratitude.obj3"),
      t("exerciseData.gratitude.obj4"),
    ],
    explanation: t("exerciseData.gratitude.explanation"),
    foundation: t("exerciseData.gratitude.foundation"),
  },
  self_compassion: {
    title: t("exerciseData.self_compassion.title"),
    objectives: [
      t("exerciseData.self_compassion.obj1"),
      t("exerciseData.self_compassion.obj2"),
      t("exerciseData.self_compassion.obj3"),
      t("exerciseData.self_compassion.obj4"),
    ],
    explanation: t("exerciseData.self_compassion.explanation"),
    foundation: t("exerciseData.self_compassion.foundation"),
  },
  values_exploration: {
    title: t("exerciseData.values_exploration.title"),
    objectives: [
      t("exerciseData.values_exploration.obj1"),
      t("exerciseData.values_exploration.obj2"),
      t("exerciseData.values_exploration.obj3"),
      t("exerciseData.values_exploration.obj4"),
    ],
    explanation: t("exerciseData.values_exploration.explanation"),
    foundation: t("exerciseData.values_exploration.foundation"),
  },
  needs_exploration: {
    title: t("exerciseData.needs_exploration.title"),
    objectives: [
      t("exerciseData.needs_exploration.obj1"),
      t("exerciseData.needs_exploration.obj2"),
      t("exerciseData.needs_exploration.obj3"),
      t("exerciseData.needs_exploration.obj4"),
    ],
    explanation: t("exerciseData.needs_exploration.explanation"),
    foundation: t("exerciseData.needs_exploration.foundation"),
  },
  problem_solving: {
    title: t("exerciseData.problem_solving.title"),
    objectives: [
      t("exerciseData.problem_solving.obj1"),
      t("exerciseData.problem_solving.obj2"),
      t("exerciseData.problem_solving.obj3"),
      t("exerciseData.problem_solving.obj4"),
    ],
    explanation: t("exerciseData.problem_solving.explanation"),
    foundation: t("exerciseData.problem_solving.foundation"),
  },
  qualities_exploration: {
    title: t("exerciseData.qualities_exploration.title"),
    objectives: [
      t("exerciseData.qualities_exploration.obj1"),
      t("exerciseData.qualities_exploration.obj2"),
      t("exerciseData.qualities_exploration.obj3"),
      t("exerciseData.qualities_exploration.obj4"),
    ],
    explanation: t("exerciseData.qualities_exploration.explanation"),
    foundation: t("exerciseData.qualities_exploration.foundation"),
  },
  capabilities_exploration: {
    title: t("exerciseData.capabilities_exploration.title"),
    objectives: [
      t("exerciseData.capabilities_exploration.obj1"),
      t("exerciseData.capabilities_exploration.obj2"),
      t("exerciseData.capabilities_exploration.obj3"),
      t("exerciseData.capabilities_exploration.obj4"),
    ],
    explanation: t("exerciseData.capabilities_exploration.explanation"),
    foundation: t("exerciseData.capabilities_exploration.foundation"),
  },
  assertiveness: {
    title: t("exerciseData.assertiveness.title"),
    objectives: [
      t("exerciseData.assertiveness.obj1"),
      t("exerciseData.assertiveness.obj2"),
      t("exerciseData.assertiveness.obj3"),
      t("exerciseData.assertiveness.obj4"),
    ],
    explanation: t("exerciseData.assertiveness.explanation"),
    foundation: t("exerciseData.assertiveness.foundation"),
  },
  self_reinforcement: {
    title: t("exerciseData.self_reinforcement.title"),
    objectives: [
      t("exerciseData.self_reinforcement.obj1"),
      t("exerciseData.self_reinforcement.obj2"),
      t("exerciseData.self_reinforcement.obj3"),
      t("exerciseData.self_reinforcement.obj4"),
    ],
    explanation: t("exerciseData.self_reinforcement.explanation"),
    foundation: t("exerciseData.self_reinforcement.foundation"),
  },
  cognitive_restructuring: {
    title: t("exerciseData.cognitive_restructuring.title"),
    objectives: [
      t("exerciseData.cognitive_restructuring.obj1"),
      t("exerciseData.cognitive_restructuring.obj2"),
      t("exerciseData.cognitive_restructuring.obj3"),
      t("exerciseData.cognitive_restructuring.obj4"),
    ],
    explanation: t("exerciseData.cognitive_restructuring.explanation"),
    foundation: t("exerciseData.cognitive_restructuring.foundation"),
  },
});

// Backward-compatible static export for non-i18n contexts
export const EXERCISE_INFO = null;
